import {
  Component,
  EventEmitter,
  Input,
  Output,
  DOCUMENT,
  inject
} from '@angular/core';
import { CoreMeasure } from './../../core.models';

@Component({
  selector: 'bepatient-measure-popup',
  templateUrl: './measure-popup.component.html',
  styleUrls: ['./measure-popup.component.scss'],
  standalone: false
})
export class MeasurePopupComponent {
  document = inject(DOCUMENT);

  @Input() measure: CoreMeasure | CoreMeasure;
  @Input() manualLabel: string;
  @Output() takeMeasure = new EventEmitter<'extra' | 'manual'>();
}
